import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";
import { SiteLayout } from "./components/SiteLayout";
import { routes } from "./data/routes";
import { Faqs } from "./pages/Faqs";
import { Home } from "./pages/Home";
import { IZone } from "./pages/IZone";
import { RinnaiDucted } from "./pages/RinnaiDucted";
import { RinnaiSplitSystems } from "./pages/RinnaiSplitSystems";
import { WhyRinnai } from "./pages/WhyRinnai";
import { WhyUs } from "./pages/WhyUs";
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="31aqeac69cmp5">
      <ScrollToTop data-id="element-1" data-mp="31b8ka0iq2fa9" />
      <SiteLayout data-id="element-2" data-mp="31bs11dwmyxmp">
        <Routes data-id="element-3" data-mp="31c9tdzg6grpc">
          <Route path={routes.home} element={<Home data-id="element-5" data-mp="2wk9xqj754kyk" />} data-id="element-4" data-mp="31ctfztgrw49p" />
          <Route path={routes.ducted} element={<RinnaiDucted data-id="element-7" data-mp="2wip2ssgwz006" />} data-id="element-6" data-mp="2wiyx2s8zrtbo" />
          <Route path={routes.split} element={<RinnaiSplitSystems data-id="element-9" data-mp="28te3lff7pdo5" />} data-id="element-8" data-mp="28u5y0mx2p5cu" />
          <Route path={routes.izone} element={<IZone data-id="element-11" data-mp="23vkzcrxgytqi" />} data-id="element-10" data-mp="28sbbx5a2f776" />
          <Route path={routes.whyRinnai} element={<WhyRinnai data-id="element-13" data-mp="23t8iki3g6pf1" />} data-id="element-12" data-mp="23u9ueosaffxt" />
          <Route path={routes.whyUs} element={<WhyUs data-id="element-15" data-mp="3iiwg8rrbto4t" />} data-id="element-14" data-mp="3ik7gihlkcdr6" />
          <Route path={routes.faqs} element={<Faqs data-id="element-17" data-mp="3mlj98vzqhf3l" />} data-id="element-16" data-mp="3ijpbavgxap74" />
          <Route path="*" element={<Home data-id="element-19" data-mp="3mk852v2dm5by" />} data-id="element-18" data-mp="3ml17jjuay8oa" />
        </Routes>
      </SiteLayout>
    </BrowserRouter>;
}